"use client";

import Link, { type LinkProps } from "next/link";
import {
    type PropsWithChildren,
    useEffect,
    type ReactElement,
    type MouseEventHandler,
    type AnchorHTMLAttributes,
} from "react";

import { progressSingleton } from "@/singletons/progress.singleton";

type ExtraLinkProps = {
    ignoreProcessing?: boolean;
} & LinkProps;

export const LinkView = ({
    ignoreProcessing,
    href,
    onClick,
    children,
    ...props
}: PropsWithChildren<ExtraLinkProps> & AnchorHTMLAttributes<HTMLAnchorElement>): ReactElement => {
    const h = href.toString();
    useEffect(
        () => () => {
            progressSingleton.finishAll();
        },
        [],
    );
    const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
        const pathname = window.location.pathname;
        const hash = window.location.hash;
        const fullPath = pathname + hash;

        if (h.startsWith("/") && h !== fullPath) {
            progressSingleton.createProgress().run(200).finish(6000);
        }
        onClick?.(e);
    };
    return (
        <Link
            {...props}
            href={h}
            onClick={ignoreProcessing ? onClick : handleClick}
            prefetch={false}
        >
            {children}
        </Link>
    );
};
